import { render } from "./SearchPlusIcon.vue?vue&type=template&id=ab7bdf9e"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__